import React from "react"
import ArticlePage from "@Screens/Knowledge/Articles/ArticlesPage"

const Medias = (props) => {
    const { navigation } = props
    return <ArticlePage navigation={navigation} />
}

export default Medias
